import { Link } from 'react-router';
import { Button, Modal } from 'components/common';

interface PurchasePlatinumUser {
  features: {
    has_brokerage?: boolean;
    has_payment_method?: boolean;
  };
}

interface PurchasePlatinumModalProps {
  onHideModal: () => void;
  onPurchasePlatinum: () => void;
  showModal: boolean;
  user: PurchasePlatinumUser;
}

const PurchasePlatinumModal = ({ onHideModal, onPurchasePlatinum, showModal, user }: PurchasePlatinumModalProps) => (
  <Modal onHide={onHideModal} show={showModal} centered>
    <div data-testid="subscriptions-purchase-platinum-modal" className="p-3">
      <h4 className="fw-bold" data-testid="subscriptions-purchase-platinum-modal-title">
        Purchase Platinum Solo
      </h4>
      <div className="my-4">
        You will keep your access to Platinum features if you&apos;re planning to{' '}
        {user.features.has_brokerage ? (
          <Link className="fw-bold" to="/settings/team-status">
            leave your team.
          </Link>
        ) : (
          <span>disconnect your Finmo account.</span>
        )}
      </div>
      <div className="my-4">
        This will <strong>not</strong> unlock any additional features.
      </div>
      <Button
        onClick={onPurchasePlatinum}
        testId="subscriptions-purchase-platinum-confirmation-button"
        text="bold"
        variant="primary-dark"
      >
        Purchase Platinum Solo
      </Button>
      <span className="ms-2">
        <Button onClick={onHideModal} text="bold" variant="border">
          Cancel
        </Button>
      </span>
    </div>
  </Modal>
);

interface PurchasePlatinumSubscriptionProps {
  onHideModal: () => void;
  onPurchasePlatinum: () => void;
  onShowPurchasePlatinumModal: () => void;
  showModal: boolean;
  user: PurchasePlatinumUser;
}

const PurchasePlatinumSubscription = ({
  onHideModal,
  onPurchasePlatinum,
  onShowPurchasePlatinumModal,
  showModal,
  user,
}: PurchasePlatinumSubscriptionProps) => (
  <div className="card" data-testid="subscriptions-purchase-platinum-card">
    <PurchasePlatinumModal
      onHideModal={onHideModal}
      onPurchasePlatinum={onPurchasePlatinum}
      showModal={showModal}
      user={user}
    />
    <div className="card-body">
      <div>
        <div className="align-items-center d-flex">
          <img alt="Platinum icon" height={76} src="/images/spotlight-logo-200x200.png" width={76} />
          <div className="flex-column ms-3">
            <h4 className="fw-bold mb-2" data-testid="subscriptions-purchase-platinum-title">
              Platinum Solo
            </h4>
            <div className="fw-bold text-1_125">
              <span>$49 / Monthly</span>
            </div>
          </div>
        </div>
        <div className="my-3">
          Platinum Solo lets you keep Platinum features when you&apos;re no longer connected to your{' '}
          {user.features.has_brokerage ? <span>team.</span> : <span>Finmo account.</span>}
        </div>
      </div>
      <Button
        disabled={!user.features.has_payment_method}
        onClick={onShowPurchasePlatinumModal}
        testId="subscriptions-purchase-platinum-open-modal-button"
        text="bold"
        variant="primary-dark"
      >
        Purchase Platinum Solo
      </Button>
      {!user.features.has_payment_method && (
        <div className="mt-3 text-0_75">You must enter payment details before purchasing Platinum Solo.</div>
      )}
    </div>
  </div>
);

export default PurchasePlatinumSubscription;
